import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandlerService } from '../../../services/shared/error-handler.service';
import { MonitoringService } from '../../service/monitoring.service';

@Component({
  selector: 'app-error-details',
  templateUrl: './error-details.component.html',
  styleUrls: ['./error-details.component.css']
})
export class ErrorDetailsComponent {
  errorId: number = 0;
  errorDetails: any = {};
  isTraceCopied = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private monitoringService: MonitoringService,
    private errorHandlerService: ErrorHandlerService
  ) {
    this.errorId = this.activatedRoute.snapshot.params['id'];
  }

  ngOnInit() {
    this.getErrorDetails();
  }

  getErrorDetails() {
    this.monitoringService.getErrorById(this.errorId).subscribe({
      next: (res) => {
        this.errorDetails = res.data;
      },
      error: (error) => {
        this.errorHandlerService.handleErorr(error);
      },
    });
  }

  reopenError() {
    this.monitoringService.reopenError(this.errorId).subscribe({
      next: (data) => {
        this.router.navigate(['/monitoring']);
      },
      error: (error) => {
        this.errorHandlerService.handleErorr(error);
      },
    });
  }

  resolveError() {
    this.monitoringService.resolveError(this.errorId).subscribe({
      next: (data) => {
        this.router.navigate(['/monitoring']);
      },
      error: (error) => {
        this.errorHandlerService.handleErorr(error);
      },
    });
  }

  addComment() {
    this.monitoringService.addErrorNote(this.errorId, this.errorDetails.comment).subscribe({
        next: (data) => {
          this.getErrorDetails();
        },
        error: (error) => {
          this.errorHandlerService.handleErorr(error);
        },
      })
  }

  async copyStackTrace(): Promise<void> {
    const stackTrace = this.errorDetails && this.errorDetails.stack_trace;
    if (!stackTrace) {
      return;
    }

    let copied = false;

    try {
      const clipboard = (navigator as any).clipboard;
      if (clipboard && window.isSecureContext) {
        await clipboard.writeText(stackTrace);
        copied = true;
      } else {
        copied = this.copyTextFallback(stackTrace);
      }
    } catch {
      copied = this.copyTextFallback(stackTrace);
    }

    if (copied) {
      this.isTraceCopied = true;
      setTimeout(() => {
        this.isTraceCopied = false;
      }, 2000);
    }
  }

  private copyTextFallback(text: string): boolean {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();

    try {
      return document.execCommand('copy');
    } catch {
      return false;
    } finally {
      document.body.removeChild(textarea);
    }
  }

  goBack() {
    this.router.navigate(['/pages/monitoring/dashboard']);
  }
}



// WEBPACK FOOTER //
// ./src/app/monitoring/components/error-details/error-details.component.ts